import { render, staticRenderFns } from "./add-gift-pack.vue?vue&type=template&id=6ef70e7e&scoped=true"
import script from "./add-gift-pack.vue?vue&type=script&lang=ts"
export * from "./add-gift-pack.vue?vue&type=script&lang=ts"
import style0 from "./add-gift-pack.vue?vue&type=style&index=0&id=6ef70e7e&prod&lang=stylus&module=true"
import style1 from "./add-gift-pack.vue?vue&type=style&index=1&id=6ef70e7e&prod&lang=stylus&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6ef70e7e",
  null
  
)

export default component.exports